export enum personnelTypes {
    LOADING = "LOADING",
    SELECTED_PERSONNEL = "SELECTED_PERSONNEL",
    GET_PERSONNEL_LIST = "GET_PERSONNEL_LIST",
    GET_SYNTHESE_PERSONNEL = "GET_SYNTHESE_PERSONNEL",
    GET_HISTORIQUE_PERSONNEL = "GET_HISTORIQUE_PERSONNEL"
}
  
export default personnelTypes;